import useSelectHelpers from 'Hooks/useSelectHelpers'

import { FormElement, Select } from 'mailup-web-components'

import { workflowCommonDataState } from 'Pages/Workflow/recoil/state/data'

import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useSetRecoilState } from 'recoil'

const InputSmsMessage = () => {
  const intl = useIntl()

  const { smsMessages } = useRecoilValue(workflowCommonDataState)
  const { IdMessage } = useRecoilValue(step2State)
  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const [smsMessageIsDirty, setSmsMessageIsDirty] = useState(false)

  const smsMessageProps = useSelectHelpers(
    IdMessage,
    smsMessages,
    true,
    smsMessageIsDirty
  )

  const handleSmsMessageChange = (value) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      IdMessage: value,
      ClickedLink: ''
    }))
    setSmsMessageIsDirty(true)
  }

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.ActivityMessageLabel'
      })}
      required
      feedback={smsMessageIsDirty && !IdMessage ? requiredFeedback : undefined}
      variant={smsMessageIsDirty && !IdMessage ? 'danger' : undefined}
    >
      <Select
        value={IdMessage}
        options={smsMessages}
        onChange={handleSmsMessageChange}
        placeholder={intl.formatMessage({
          id: 'Load.AutomationWorkflow.ActivityMessagePlaceholder'
        })}
        {...smsMessageProps}
      />
    </FormElement>
  )
}

export default InputSmsMessage
